const styles = theme => ({
wow:{
  lineHeight: '20px!important',
}
})

export default styles



// WEBPACK FOOTER //
// ./src/components/table/cells/rowlink/styles.js